import React from "react";
const Header = (props) => (
    <div className="banner">
        <h1>{props.title}</h1>
    </div>
);

export default Header;